

















import { Component, Prop, Vue } from 'vue-property-decorator'
import { ScormAPI, ScormAPI2004 } from '@/lib/ScormApi'
import { LOG_LEVEL_ERROR } from "@/lib/ScormApi/contants"

declare global {
  interface Window {
    API: ScormAPI;
    API_1484_11: ScormAPI2004;
  }
}

@Component
export default class ScormPlayer extends Vue {
  @Prop()
  public path!: string

  @Prop()
  public studentData: any

  @Prop({
    default: LOG_LEVEL_ERROR
  })
  public logLevel!: number

  private src = ''
  private objectives!: any[]
  private readonly API_1484_11: ScormAPI2004
  private readonly API: ScormAPI

  constructor () {
    super()
    // Init SCORM APIs
    this.API = new ScormAPI()
    this.API_1484_11 = new ScormAPI2004()

    // Set API Logs level
    this.API.setLogLevel(this.logLevel)
    this.API_1484_11.setLogLevel(this.logLevel)

    // Init scorm Events
    this.initScorm2004Events(this.API_1484_11)
    this.initScormEvents(this.API)

    window.API = this.API
    window.API_1484_11 = this.API_1484_11
  }

  private beforeMount () {
    const imsmanifestPath = `${ this.path }/imsmanifest.xml`

    fetch(imsmanifestPath)
      .then((data) => data.text())
      .then((xml) => this.parseImsmanifest(xml))
      .then(() => {
        this.API_1484_11.loadFromJSON({
          ...this.studentData,
          objectives: {
            childArray: this.objectives
          }
        }, 'cmi')

        this.API.loadFromJSON({
          ...this.studentData,
          objectives: {
            childArray: this.objectives
          }
        }, 'cmi')
      })
      .catch((e) => console.log(e))
  }

  private parseImsmanifest (xml: string): void {
    const parser = new DOMParser()
    const dom = parser.parseFromString(xml, 'application/xml')

    // Find resource file
    const resourceNodes = dom.querySelectorAll('resource')
    if (resourceNodes.length) {
      resourceNodes.forEach((element) => {
        const href = element.getAttribute('href')
        if (href) {
          this.src = `${ this.path }/${ href }`
        }
      })
    }

    // Find objectives
    const objectivesNodes = dom.querySelectorAll('objective')
    if (objectivesNodes.length) {
      const objectives: any[] = []
      objectivesNodes.forEach((element) => {
        objectives.push({
          id: element.getAttribute('objectiveID')
        })
      })
      this.objectives = objectives
    }
  }

  private initScorm2004Events (api: ScormAPI2004) {
    api.on('Initialize', (...args: any[]) => this.$emit('initialize', ...args))
    api.on('Terminate', (...args: any[]) => this.$emit('finish', null, JSON.stringify(this.API_1484_11.cmi.toJSON())))
    api.on('GetValue', (...args: any[]) => this.$emit('get-value', ...args, api.SetValue.bind(api)))
    api.on('SetValue', (...args: any[]) => this.$emit('set-value', ...args))
    api.on('Commit', (...args: any[]) => this.$emit('commit', ...args))
    api.on('GetLastError', (...args: any[]) => this.$emit('get-last-error', ...args))
    api.on('GetErrorString', (...args: any[]) => this.$emit('get-error-string', ...args))
    api.on('GetDiagnostic', (...args: any[]) => this.$emit('get-diagnostic', ...args))
  }

  private initScormEvents (api: ScormAPI) {
    api.on('LMSInitialize', (...args: any[]) => this.$emit('initialize', ...args))
    api.on('LMSFinish', (...args: any[]) => this.$emit('finish', null, JSON.stringify(this.API.cmi.toJSON())))
    api.on('LMSGetValue', (...args: any[]) => this.$emit('get-value', ...args, api.LMSSetValue.bind(api)))
    api.on('LMSSetValue', (...args: any[]) => this.$emit('set-value', ...args))
    api.on('LMSCommit', (...args: any[]) => this.$emit('commit', ...args))
    api.on('LMSGetLastError', (...args: any[]) => this.$emit('get-last-error', ...args))
    api.on('LMSGetErrorString', (...args: any[]) => this.$emit('get-error-string', ...args))
    api.on('LMSGetDiagnostic', (...args: any[]) => this.$emit('get-diagnostic', ...args))
  }
}
